import { vehicleHistoryKey } from './vehicleHistoryStorage.js'

export const HERO_PANEL = 'panel'
export const HERO_FINDER = 'finder'
export const HERO_RESERVED = 'reserved'

export const PRODUCT_TAB_SELECTION = 'selection'
export const PRODUCT_TAB_RECENTLY_VIEWED = 'recently_viewed'

const RECENT_SEARCHES_LIMIT = 3

const VEHICLE_TYPE_ICONS = ['car', 'motorcycle', 'truck', 'tractor']

const recentSearchesBesides = (selectedVehicle, history) => {
  const seen = new Set()
  return (history || [])
    .filter(searched => searched.id !== selectedVehicle.id)
    .filter(searched => {
      const key = vehicleHistoryKey(searched)
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })
    .slice(0, RECENT_SEARCHES_LIMIT)
}

export function heroVehicle({
  selectedVehicle = null,
  history = [],
  hasSelectedVehicleCookie = false,
  restored = false,
} = {}) {
  if (!restored) {
    return {
      mode: hasSelectedVehicleCookie ? HERO_RESERVED : HERO_FINDER,
      vehicle: null,
      recentSearches: [],
    }
  }

  if (!selectedVehicle) {
    return { mode: HERO_FINDER, vehicle: null, recentSearches: [] }
  }

  return {
    mode: HERO_PANEL,
    vehicle: selectedVehicle,
    recentSearches: recentSearchesBesides(selectedVehicle, history),
  }
}

export function heroVehicleIcon(vehicle) {
  const type = vehicle?.vehicle_type?.identifier
  return VEHICLE_TYPE_ICONS.includes(type) ? type : 'car'
}

export function initialProductTab(recentlyViewed) {
  return recentlyViewed.length
    ? PRODUCT_TAB_RECENTLY_VIEWED
    : PRODUCT_TAB_SELECTION
}
